import { LoadingLayer } from '../../LoadingLayer';
import { useEffect, useState } from 'react';
import './Admin.css';
import { SideMenuAdmin } from './SideMenuAdmin';
import PropTypes from 'prop-types';

export const fetchAdminScholarships = async (setScholarships) => {
  try {
    const response = await fetch(
      'https://nt6dwl1xpc.execute-api.us-west-1.amazonaws.com/produccion/admin/scholarships',
      {
        headers: {
          'user-token': localStorage.getItem('id_token'),
        },
      },
    );
    const data = await response.json();
    console.log(data);
    setScholarships(data.Items);
  } catch (error) {
    console.error('Error:', error);
    return error;
  }
};

const updateScholarshipStatus = async (scholarshipId, updatedAt, newStatus) => {
  await fetch(
    'https://nt6dwl1xpc.execute-api.us-west-1.amazonaws.com/produccion/admin/receipts/' + scholarshipId,
    {
      method: 'POST',
      headers: {
        'user-token': localStorage.getItem('id_token'),
      },
      body: JSON.stringify({
        status: newStatus,
        updated_at: updatedAt,
      }),
    },
  );
};

const STATUS_OPTIONS = [
  { value: 'Sent', label: 'Sent' },
  { value: 'Creating reports', label: 'Creating reports' },
  { value: 'Receipt sent', label: 'Receipt sent' },
  { value: 'Approved', label: 'Approved' },
  { value: 'Rejected', label: 'Rejected' },
];

export const AdminScholarshipView = () => {
  const [scholarships, setScholarships] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [searchQuery, setSearchQuery] = useState('');
  const [statusEdits, setStatusEdits] = useState({});
  const [savingStatus, setSavingStatus] = useState({});

  useEffect(() => {
    setIsLoading(true);
    setLoadingMessage('Loading scholarships');
    fetchAdminScholarships(setScholarships).then(() => {
      setIsLoading(false);
    });
  }, []);

  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
    }));
  };

  const getFiltered = (list) => {
    if (!list || !searchQuery.trim()) return list;
    const q = searchQuery.toLowerCase().trim();
    return list.filter((s) =>
      (s.name || '').toLowerCase().includes(q) ||
      (s.email || '').toLowerCase().includes(q) ||
      (s.abstractTitle || '').toLowerCase().includes(q) ||
      (s.abstractCode || '').toLowerCase().includes(q) ||
      (s.career || '').toLowerCase().includes(q) ||
      (s.adscription || '').toLowerCase().includes(q) ||
      (s.status || '').toLowerCase().includes(q),
    );
  };

  const getSorted = (list) => {
    if (!list || !sortConfig.key) return list;
    return [...list].sort((a, b) => {
      const valA = (a[sortConfig.key] || '').toString().toLowerCase();
      const valB = (b[sortConfig.key] || '').toString().toLowerCase();
      if (valA < valB) return sortConfig.direction === 'asc' ? -1 : 1;
      if (valA > valB) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });
  };

  const sortedScholarships = getSorted(getFiltered(scholarships));

  const SortIcon = ({ columnKey }) => {
    if (sortConfig.key !== columnKey)
      return <span style={{ opacity: 0.3, marginLeft: 4 }}>↕</span>;
    return <span style={{ marginLeft: 4 }}>{sortConfig.direction === 'asc' ? '↑' : '↓'}</span>;
  };

  SortIcon.propTypes = {
    columnKey: PropTypes.string.isRequired,
  };

  const handleStatusChange = (id, newStatus) => {
    setStatusEdits((prev) => ({ ...prev, [id]: newStatus }));
  };

  const handleStatusSave = async (scholarship) => {
    const newStatus = statusEdits[scholarship.id];
    if (!newStatus || newStatus === scholarship.status) return;

    setSavingStatus((prev) => ({ ...prev, [scholarship.id]: true }));
    try {
      await updateScholarshipStatus(scholarship.id, scholarship.updated_at, newStatus);
      setScholarships((prev) =>
        prev ? prev.map((s) => s.id === scholarship.id ? { ...s, status: newStatus } : s) : prev,
      );
      setStatusEdits((prev) => {
        const next = { ...prev };
        delete next[scholarship.id];
        return next;
      });
    } catch (error) {
      alert('Error updating status');
    } finally {
      setSavingStatus((prev) => ({ ...prev, [scholarship.id]: false }));
    }
  };

  const downloadCsv = () => {
    if (!scholarships || scholarships.length === 0) return;

    const esc = (val) => `"${String(val ?? '').replace(/"/g, '""')}"`;

    const headers = [
      'Name',
      'Email',
      'Status',
      'Career',
      'Adscription',
      'Country',
      'City',
      'Abstract Title',
      'Abstract Code',
      'Food Allergies',
      'Created At',
      'Updated At',
      'Studies Proof URL',
    ];

    const csvRows = [headers.map(esc).join(',')];

    scholarships.forEach((s) => {
      const row = [
        s.name,
        s.email,
        s.status,
        s.career,
        s.adscription,
        s.country,
        s.city,
        s.abstractTitle,
        s.abstractCode,
        s.haveFoodAllergies ? (s.foodAllergies || 'Yes') : 'No',
        s.created_at,
        s.updated_at,
        s.studiesProof,
      ].map(esc);
      csvRows.push(row.join(','));
    });

    const csvString = '\uFEFF' + csvRows.join('\n');
    const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'scholarships.csv';
    link.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="snn-user-home-main-wrapper">
      <SideMenuAdmin />
      <div className="snn-abstract-submission-main-grid-wrapper">
        <LoadingLayer isLoading={isLoading} action={loadingMessage} />

        <section className="snn-expand-grid-4">
          <h1 className="snn-user-home-main-content-header">Scholarship Requests</h1>

          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '16px', alignItems: 'center' }}>
            <button
              onClick={downloadCsv}
              disabled={!scholarships || scholarships.length === 0}
              style={{
                padding: '8px 16px',
                backgroundColor: '#0b6ef6',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontWeight: 600,
              }}
            >
              Download CSV{' '}
              <span className="material-symbols-outlined" style={{ verticalAlign: 'middle', marginLeft: 4 }}>
                download
              </span>
            </button>
          </div>

          {/* Search bar */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
            <div style={{ position: 'relative', flex: 1, maxWidth: '400px' }}>
              <span
                className="material-symbols-outlined"
                style={{
                  position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)',
                  color: '#94a3b8', fontSize: '20px',
                }}
              >
                search
              </span>
              <input
                type="text"
                placeholder="Search by name, email, abstract, career, adscription or status..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                style={{
                  width: '100%', padding: '10px 12px 10px 36px', fontSize: '14px',
                  border: '1px solid #ddd', borderRadius: '6px', outline: 'none',
                  boxSizing: 'border-box',
                }}
              />
              {searchQuery && (
                <button
                  onClick={() => setSearchQuery('')}
                  style={{
                    position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)',
                    background: 'none', border: 'none', cursor: 'pointer', color: '#94a3b8',
                    fontSize: '18px', lineHeight: 1, padding: 0,
                  }}
                >×</button>
              )}
            </div>
            {scholarships && (
              <span style={{ fontSize: '13px', color: '#666', whiteSpace: 'nowrap' }}>
                {sortedScholarships ? sortedScholarships.length : 0} / {scholarships.length} scholarships
              </span>
            )}
          </div>

          {/* Table */}
          {scholarships && (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
                <thead>
                  <tr style={{ backgroundColor: '#f5f5f5', textAlign: 'left' }}>
                    <th style={{ padding: '10px 12px', borderBottom: '2px solid #ddd', cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort('name')}>
                      Name <SortIcon columnKey="name" />
                    </th>
                    <th style={{ padding: '10px 12px', borderBottom: '2px solid #ddd', cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort('email')}>
                      Email <SortIcon columnKey="email" />
                    </th>
                    <th style={{ padding: '10px 12px', borderBottom: '2px solid #ddd', cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort('career')}>
                      Career <SortIcon columnKey="career" />
                    </th>
                    <th style={{ padding: '10px 12px', borderBottom: '2px solid #ddd', cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort('adscription')}>
                      Adscription <SortIcon columnKey="adscription" />
                    </th>
                    <th style={{ padding: '10px 12px', borderBottom: '2px solid #ddd' }}>
                      Country / City
                    </th>
                    <th style={{ padding: '10px 12px', borderBottom: '2px solid #ddd', cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort('abstractTitle')}>
                      Abstract <SortIcon columnKey="abstractTitle" />
                    </th>
                    <th style={{ padding: '10px 12px', borderBottom: '2px solid #ddd' }}>
                      Food Allergies
                    </th>
                    <th style={{ padding: '10px 12px', borderBottom: '2px solid #ddd', cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort('status')}>
                      Status <SortIcon columnKey="status" />
                    </th>
                    <th style={{ padding: '10px 12px', borderBottom: '2px solid #ddd', cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort('created_at')}>
                      Created At <SortIcon columnKey="created_at" />
                    </th>
                    <th style={{ padding: '10px 12px', borderBottom: '2px solid #ddd' }}>
                      Downloads
                    </th>
                    <th style={{ padding: '10px 12px', borderBottom: '2px solid #ddd', minWidth: '200px' }}>
                      Update Status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {sortedScholarships && sortedScholarships.map((s) => {
                    const currentStatus = statusEdits[s.id] ?? s.status;
                    const hasUnsavedChange = statusEdits[s.id] !== undefined && statusEdits[s.id] !== s.status;
                    const isSaving = savingStatus[s.id];

                    return (
                      <tr key={s.id} style={{ borderBottom: '1px solid #eee' }}>
                        <td style={{ padding: '8px 12px', fontWeight: 600 }}>{s.name}</td>
                        <td style={{ padding: '8px 12px', fontSize: '13px' }}>{s.email}</td>
                        <td style={{ padding: '8px 12px', fontSize: '13px' }}>{s.career}</td>
                        <td style={{ padding: '8px 12px', fontSize: '13px' }}>{s.adscription}</td>
                        <td style={{ padding: '8px 12px', fontSize: '13px' }}>
                          {[s.country, s.city].filter(Boolean).join(', ') || '—'}
                        </td>
                        <td style={{ padding: '8px 12px', maxWidth: '200px' }}>
                          <div style={{ fontSize: '13px', fontWeight: 600 }}>{s.abstractTitle || '—'}</div>
                          {s.abstractCode && (
                            <div style={{ fontSize: '11px', color: '#666', marginTop: '2px' }}>
                              Code: {s.abstractCode}
                            </div>
                          )}
                        </td>
                        <td style={{ padding: '8px 12px', textAlign: 'center' }}>
                          {s.haveFoodAllergies ? (
                            <span style={{ color: '#dc2626', fontWeight: 600, fontSize: '12px' }}>
                              {s.foodAllergies || 'Yes'}
                            </span>
                          ) : (
                            <span style={{ color: '#94a3b8', fontSize: '12px' }}>No</span>
                          )}
                        </td>
                        <td style={{ padding: '8px 12px' }}>
                          <span style={{
                            display: 'inline-block', padding: '2px 8px', borderRadius: '12px',
                            fontSize: '12px', fontWeight: 600,
                            backgroundColor:
                              s.status === 'Approved' ? '#dcfce7' :
                              s.status === 'Rejected' ? '#fef2f2' :
                              s.status === 'Receipt sent' ? '#dbeafe' :
                              s.status === 'Creating reports' ? '#fef3c7' : '#e0e7ff',
                            color:
                              s.status === 'Approved' ? '#166534' :
                              s.status === 'Rejected' ? '#991b1b' :
                              s.status === 'Receipt sent' ? '#1d4ed8' :
                              s.status === 'Creating reports' ? '#92400e' : '#3730a3',
                          }}>
                            {s.status}
                          </span>
                        </td>
                        <td style={{ padding: '8px 12px', fontSize: '13px', whiteSpace: 'nowrap' }}>
                          {s.created_at}
                        </td>
                        <td style={{ padding: '8px 12px' }}>
                          {s.studiesProof ? (
                            <a
                              href={s.studiesProof}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                display: 'inline-flex', alignItems: 'center', gap: '4px',
                                color: '#0b6ef6', textDecoration: 'none', fontSize: '12px', fontWeight: 600,
                              }}
                            >
                              <span className="material-symbols-outlined" style={{ fontSize: '16px' }}>
                                sim_card_download
                              </span>
                              Studies Proof
                            </a>
                          ) : (
                            <span style={{ color: '#94a3b8', fontSize: '12px' }}>—</span>
                          )}
                        </td>
                        <td style={{ padding: '8px 12px' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <select
                              value={currentStatus}
                              onChange={(e) => handleStatusChange(s.id, e.target.value)}
                              style={{
                                padding: '4px 6px', fontSize: '12px', borderRadius: '4px',
                                border: '1px solid #ccc', flex: 1,
                              }}
                            >
                              {STATUS_OPTIONS.map((opt) => (
                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                              ))}
                            </select>
                            <button
                              onClick={() => handleStatusSave(s)}
                              disabled={!hasUnsavedChange || isSaving}
                              style={{
                                padding: '4px 10px', fontSize: '12px', borderRadius: '4px', border: 'none',
                                backgroundColor: hasUnsavedChange ? '#f59e0b' : '#22c55e',
                                color: '#fff',
                                cursor: hasUnsavedChange ? 'pointer' : 'not-allowed',
                                opacity: hasUnsavedChange ? 1 : 0.5,
                                whiteSpace: 'nowrap',
                              }}
                            >
                              {isSaving ? '...' : hasUnsavedChange ? 'Save' : '✓'}
                            </button>
                          </div>
                          {hasUnsavedChange && (
                            <span style={{ fontSize: '11px', color: '#f59e0b', fontWeight: 600, marginTop: '2px', display: 'block' }}>
                              ● Unsaved
                            </span>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </section>
      </div>
    </div>
  );
};
